// src/App.js
import React from 'react';
import AppRouter from './router/router'; // Import the AppRouter component
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './services/GlobalContext'
import { Toaster } from 'react-hot-toast';
import { useGlobalContext } from './services/GlobalContext';
import { mainAssets } from './services/constant';
function App() {
  const { loading } = useGlobalContext();
  return (
    <>
      <div className="App">
        <AppRouter /> {/* Render the router */}
        <Toaster position="top-right" toastOptions={{
          style: {
            fontSize: '1.5rem'
          },
        }} />

        {/* Loader overlay (absolute, so it doesn't split the content) */}
      </div>
      {loading && (
        <div className='loader-overlay'>
          {/* <CircleLoader
            color='#F9BC04'
            loading={loading}
            cssOverride={override}
            size={50}
            aria-label="Loading Spinner"
            data-testid="loader"
          /> */}
          <img src={mainAssets.MediPet_loading} style={{width:'100px' , height:'100px'}}/>
        </div>
      )}
    </>
  );
}

export default App;
